import type { BasketItem } from '@egr/wcf/modules/bsk';
import type { ShareContent } from '../ShareManager';
import type { ShareTask } from '../ShareTask';
import { ShareContentSource } from '../ShareManager';
import { setItemInactiveState } from '@egr/wcf/modules/bsk/actions';
import { isNotNullOrEmpty } from '@egr/wcf/modules/utils/string';
import { getApp } from '@egr/xbox/base-app/App';
import { assert } from '@egr/xbox/utils/Debug';
import { SessionExportFormat } from '@egr/xbox/utils/FileFormats';

export async function *shareObxHandler(shareTask: ShareTask): AsyncIterableIterator<ShareContent> {
    const app = await getApp();
    const items: Array<BasketItem> = shareTask.itemIds.map((item) => app.eaiwsBasket.getItemById(item)).filter((item): item is BasketItem => item !== null);
    const excludedItems: Array<BasketItem> = items.filter((item) => item?.isExcludedFromCalculations);
    let revertAlternativeState: boolean = false;

    excludedItems.map(async () => {
        await setItemInactiveState(app.eaiwsBasket, items, 'None');
        revertAlternativeState = true;
    });

    const obxUrl: string = await app.eaiwsSession.basket.copy(shareTask.itemIds, null, null);

    if (revertAlternativeState) {
        await setItemInactiveState(app.eaiwsBasket, items, 'Alternative');
    }

    if (assert(isNotNullOrEmpty(obxUrl), 'obx url should not be empty')) {
        shareTask.telemetryEventQueue?.addPartialEvent({name: 'obx'});
        yield {
            source: ShareContentSource.REMOTE_URL,
            content: obxUrl,
            filename: shareTask.shareFilenameManager.getFilename(SessionExportFormat.OBX.extension),
            filetype: SessionExportFormat.OBX
        };
    }
}